import React, { useState, useEffect } from "react";
import { Row, Col, Modal, Form, message, Button, Select, Image } from "antd";
import { InputWrapper } from "../input";

import styled from "styled-components";
import { addOrUpdateData } from "../../apis/generalApis";

const StyledContent = styled.div`
  .form-label {
    text-align: left;
    margin-bottom: 8px;
    font-size: 16px;
  }
`;

const AddServiceModal = (props) => {
  const [subServiceForm] = Form.useForm();
  const [serviceForm] = Form.useForm();
  const [priceForm] = Form.useForm();
  const [toggleSubServiceModal, setToggleSubServiceModal] = useState(false);
  const [togglePriceModal, setTogglePriceModal] = useState(false);
  const [imageLoader, setImageLoader] = useState(false);
  const { visible, onCancel } = props;
  const [currentSubServices, setCurrentSubServices] = useState([]);
  const [currentSubService, setCurrentSubService] = useState({
    title: "",
    image: "",
  });

  const [service, setService] = useState({
    serviceTitle: "",
    icon: "",
  });

  const handleChangeService = (e) => {
    const { name, value } = e.target;
    setService({ ...service, [name]: value });
  };

  const handleSubServiceForm = () => {
    if (currentSubService.image === "" || currentSubService.title == "") {
      message.error("1 or more fields missing");
      return;
    }
    setCurrentSubServices([...currentSubServices, currentSubService]);
    setToggleSubServiceModal(false);
  };

  const handleServiceForm = async () => {
    if (service.serviceTitle === "" || service.icon === "") {
      message.error("1 or two fields missing.");
      return;
    }
    let formData = new FormData();
    formData.append("name", service.serviceTitle);
    formData.append("icon", service.icon);
    let response = await addOrUpdateData("add-service", formData);
    if (response && response.id != undefined) {
      message.success("Service added successfully!");
      if (currentSubServices.length === 0) {
        setService({
          serviceTitle: "",
          icon: "",
        });
        props.getAllServices();
      }
      if (currentSubServices.length > 0) {
        currentSubServices.forEach(async (item, index) => {
          let formData = new FormData();
          formData.append("title", item.title);
          formData.append("icon", item.image);
          formData.append("service_id", response.id);
          let subServiceResponse = await addOrUpdateData("add-sub-service", formData);
          if (subServiceResponse != null && index === currentSubServices.length - 1) {
            setService({
              serviceTitle: "",
              icon: "",
            });
            props.getAllServices();
          }
        });
      }
    }
    closeModal();
    serviceForm.resetFields();
  };

  const handlePriceForm = (formValues) => {

    let c = [];
    c = formValues.values.map((val, Index) => {
      return {
        Time: 0,
        Value: 0,
        name: val,
        Index,
        title: formValues.type,
        Index: currentSubServices.prices.length + 1,
      };
    });

    let a = currentSubServices.prices;
    a.push({
      Time: 0,
      Value: 0,
      name: formValues.priceName,
      [formValues.type]: c,
    });

    setCurrentSubServices({
      ...currentSubServices,
      prices: a,
    });
    priceForm.resetFields();
    setTogglePriceModal(false);
    message.success("Price added successfully");
  };

  const handleChangeSubService = (e) => {
    const { name, value } = e.target;
    setCurrentSubService({ ...currentSubService, [name]: value });
  };

  const closeModal = () => {
    serviceForm.resetFields();
    setService({
      serviceTitle: "",
      icon: "",
    });

    onCancel(); // Close the modal
  };

  return (
    <>
      <Modal
        title={"Add sub service"}
        visible={toggleSubServiceModal}
        onCancel={() => {
          setToggleSubServiceModal(false);
        }}
        footer={null}
        centered
      >
        <StyledContent>
          <Form
            form={subServiceForm}
            id="Add_SubService"
            onFinish={handleSubServiceForm}
            initialValues={{ title: "" }}
            validateTrigger="onFinish"
          >
            <Row justify="space-between">
              <Col span={11}>
                <h4 className="form-label">*Sub-Service Title</h4>
                <Form.Item
                  name="title"
                  rules={[
                    {
                      required: true,
                      max: 20,
                      message: "Sub-service title is required.",
                    },
                  ]}
                >
                  <InputWrapper
                    name="title"
                    value={currentSubService.title}
                    placeholder="Service Name"
                    onChange={handleChangeSubService}
                  />
                </Form.Item>
              </Col>
              <Col span={11}>
                <h4 className="form-label">*upload image</h4>

                {imageLoader == true ? (
                  <h4>Loading...</h4>
                ) : (
                  <Image width={200} src={currentSubService.image} preview={true} />
                )}
                <input
                  type="file"
                  id="files"
                  placeholder="Edit image"
                  title="choose image"
                  name="icon"
                  onChange={async (event) => {
                    if (event.target.files[0]) {
                      setCurrentSubService({
                        ...currentSubService,
                        image: event.target.files[0],
                      });
                      setImageLoader(false);
                    } else {
                      setCurrentSubServices({ ...currentSubServices, icon: "" });
                    }
                  }}
                />
              </Col>
            </Row>

            <Row justify="end" align="middle">
              <Col span={7} style={{ paddingLeft: "10px" }}>
                <Button
                  block
                  shape="round"
                  type="danger"
                  size="default"
                  onClick={() => {
                    setToggleSubServiceModal(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
              <Col span={7} style={{ paddingLeft: "10px" }}>
                <Button
                  block
                  shape="round"
                  type="primary"
                  size="default"
                  style={{
                    outline: "none",
                    border: "none",
                    backgroundColor: "#49D3CE",
                  }}
                  htmlType="submit"
                >
                  {"Ok"}
                </Button>
              </Col>
            </Row>
          </Form>
        </StyledContent>
      </Modal>

      <Modal
        title={"Add price,color and sizes"}
        visible={togglePriceModal}
        onCancel={() => {
          setTogglePriceModal(false);
        }}
        footer={null}
        centered
      >
        <StyledContent>
          <Form
            form={priceForm}
            id="Add_SubService"
            onFinish={handlePriceForm}
            validateTrigger="onFinish"
          >
            <Row justify="space-between">
              <Col span={11}>
                <h4 className="form-label">*Name</h4>
                <Form.Item name="priceName" rules={[{ required: true, max: 20 }]}>
                  <InputWrapper maxLength={20} name="name" placeholder="Service Name" />
                </Form.Item>
              </Col>

              <Col span={11}>
                <h4 className="form-label">*Type</h4>

                <Form.Item name="type" rules={[{ required: true }]}>
                  <InputWrapper
                    name="type"
                    style={{ width: "100%" }}
                    placeholder="Add Type"
                  ></InputWrapper>
                </Form.Item>
              </Col>
              <Col span={11}>
                <h4 className="form-label">*Values</h4>
                <Form.Item name="values" rules={[{ required: true }]}>
                  <Select
                    mode="tags"
                    style={{ width: "100%" }}
                    placeholder="Add Value"
                  ></Select>
                </Form.Item>
              </Col>
            </Row>

            <Row justify="end" align="middle">
              <Col span={7} style={{ paddingLeft: "10px" }}>
                <Button
                  block
                  shape="round"
                  type="danger"
                  size="default"
                  onClick={() => {
                    setTogglePriceModal(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
              <Col span={7} style={{ paddingLeft: "10px" }}>
                <Button
                  block
                  shape="round"
                  type="primary"
                  size="default"
                  style={{
                    outline: "none",
                    border: "none",
                    backgroundColor: "#49D3CE",
                  }}
                  htmlType="submit"
                >
                  {"Ok"}
                </Button>
              </Col>
            </Row>
          </Form>
        </StyledContent>
      </Modal>

      <Modal
        title={"Add Service"}
        visible={props.visible}
        onCancel={() => {
          serviceForm.resetFields();
          closeModal();
          return props.onCancel();
        }}
        footer={null}
        centered
      >
        <StyledContent>
          <Form
            form={serviceForm}
            id="Add_Coupon"
            onFinish={handleServiceForm}
            validateTrigger="onFinish"
            initialValues={{ icon: "", serviceTitle: "" }}
          >
            <Row justify="space-between">
              <Col span={24}>
                <h4 className="form-label">*Service Title</h4>
                <Form.Item
                  name="ServiceTitle"
                  rules={[
                    { required: true, max: 20, message: "Service title is required" },
                  ]}
                >
                  <InputWrapper
                    maxLength={20}
                    value={service.serviceTitle}
                    name="serviceTitle"
                    placeholder="Service Name"
                    onChange={handleChangeService}
                  />
                </Form.Item>
              </Col>
              <Col span={11}>
                <h4 className="form-label">*upload image</h4>
                {imageLoader == true ? (
                  <h4>Loading...</h4>
                ) : (
                  <Image width={200} src={service.icon} preview={false} />
                )}
                <h4 className="form-label">Image</h4>
                <input
                  type="file"
                  id="files"
                  placeholder="Image"
                  title="choose image"
                  name="icon"
                  onChange={async (event) => {
                    if (event.target.files[0]) {
                      setService({ ...service, icon: event.target.files[0] });
                    } else {
                      setService({ ...service, icon: "" });
                    }
                  }}
                />
              </Col>

              <Col span={24} style={{ marginTop: 32 }}>
                {currentSubServices?.map((item, index) => {
                  return (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <p>{item.title}</p>
                      <Button
                        onClick={() => {
                          let arr = [...currentSubServices];
                          arr.splice(index, 1);
                          setCurrentSubServices(arr);
                        }}
                        type="danger"
                      >
                        Delete
                      </Button>
                    </div>
                  );
                })}
              </Col>

              <Col span={11} style={{ marginTop: 32 }}>
                <Form.Item name="sub Service">
                  <Button
                    onClick={() => {
                      setToggleSubServiceModal(true);
                    }}
                    block
                    shape="round"
                    type="primary"
                    size="default"
                    style={{
                      outline: "none",
                      border: "none",
                      backgroundColor: "#49D3CE",
                    }}
                  >
                    Add Sub Service
                  </Button>
                </Form.Item>
              </Col>
            </Row>

            <br />

            <Row justify="end" align="middle">
              <Col span={7} style={{ paddingLeft: "10px" }}>
                <Button
                  block
                  shape="round"
                  type="danger"
                  size="default"
                  onClick={() => {
                    closeModal();
                    serviceForm.resetFields();
                  }}
                >
                  Cancel
                </Button>
              </Col>
              <Col span={7} style={{ paddingLeft: "10px" }}>
                <Button
                  block
                  shape="round"
                  type="primary"
                  size="default"
                  style={{
                    outline: "none",
                    border: "none",
                    backgroundColor: "#49D3CE",
                  }}
                  htmlType="submit"
                >
                  {"Ok"}
                </Button>
              </Col>
            </Row>
          </Form>
        </StyledContent>
      </Modal>
    </>
  );
};

AddServiceModal.defaultProps = {
  onCancel: () => {},
  currentCoupon: { _id: null },
};

export default AddServiceModal;
